import type { Optional } from '@festina-life/core'
import { paperStyles } from '@festina-life/ui/libs'
import cx from 'classnames'
import type { ReactNode, Ref } from 'react'
type Props = {
  children?: ReactNode
  className?: string
  label?: Optional<string>
  isTransparent?: boolean
  ref?: Ref<HTMLElement>
}

/**
 * Container used for FPlus code that's shown in a scrollable view. Provides basic
 * styling to the background.
 */
export const FPlusCodeContainer = ({
  children,
  className,
  label,
  ref,
  isTransparent = false,
}: Props) => (
  <div
    className={cx(
      'group group/editor rounded-md flex p-2 size-full min-h-[3em] items-center',
      { relative: !!label },
      !isTransparent ? paperStyles({ isFaded: true }) : undefined,
      className,
    )}
    ref={ref as Ref<HTMLDivElement>}
  >
    {!!label && (
      <div className="absolute right-2 top-0 text-sm font-medium uppercase text-gray-300">
        {label}
      </div>
    )}
    {children}
  </div>
)
